import React, { useCallback, useState, useMemo, useEffect } from "react";
import { MemoPageSize, MemoPagination } from "..";
export var Pager = function (props) {
    var _a = useState(props.selectedPageNumber), selectedPageNumber = _a[0], setSelectedPageNumber = _a[1];
    var _b = useState(props.selectedPageSize), selectedPageSize = _b[0], setSelectedPageSize = _b[1];
    useEffect(function () {
        setSelectedPageNumber(props.selectedPageNumber);
    }, [props.selectedPageNumber]);
    useEffect(function () {
        setSelectedPageSize(props.selectedPageSize);
    }, [props.selectedPageSize]);
    var onPageChange = useCallback(function (value) {
        setSelectedPageNumber(value);
        if (props.onPageChange) {
            props.onPageChange(value);
        }
    }, [props]);
    var onPageSizeChange = useCallback(function (value) {
        setSelectedPageSize(value);
        setSelectedPageNumber(1);
        if (props.onPageSizeChange) {
            props.onPageSizeChange(value);
        }
    }, [props]);
    var showPager = useCallback(function () {
        return props.showSinglePage || Math.ceil((props.totalItems || 0) / (selectedPageSize || 1)) > 1;
    }, [props, selectedPageSize]);
    var pageSizeOptions = props.pageSizeOptions, pageSizeItemTemplate = props.pageSizeItemTemplate, view = props.view, disablePagination = props.disablePagination;
    var FinalPager = useMemo(function () {
        return showPager() ? (React.createElement(React.Fragment, null,
            React.createElement(MemoPagination, { onPageChange: onPageChange, currentPageNumber: selectedPageNumber, pageSize: selectedPageSize, total: props.totalItems, formatNumber: props.formatNumber, disablePagination: disablePagination }),
            React.createElement(MemoPageSize, { onChange: onPageSizeChange, selectedValue: selectedPageSize, options: pageSizeOptions, itemTemplate: pageSizeItemTemplate, view: view }))) : null;
    }, [
        onPageChange,
        onPageSizeChange,
        pageSizeItemTemplate,
        pageSizeOptions,
        props.totalItems,
        selectedPageNumber,
        selectedPageSize,
        showPager,
        props.formatNumber,
        view,
    ]);
    return FinalPager;
};
export var MemoPager = React.memo(Pager);
//# sourceMappingURL=PagerFunctional.js.map